<div *ngIf="content" class="here-for-you banner" (ngInit)="onElementInit()">
    <div class="content">
        <img [src]="content.contactUsImage" alt="" class="max-speaker" />
        <h2 [innerHtml]="content.contactUsTitle | sanitizeHtml"></h2>
        <h3 [innerHtml]="content.contactUsText | sanitizeHtml"></h3>
        <a class="home-button" title="" id="contact-us" (click)="onClick()">{{ content.contactUsButton.text }}</a>
    </div>
</div>